import * as React from "react"
import {Box, Typography, Link} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";


export default function PricingDiscountTableTitleLink({ title, url=null, tooltip="" }) {

    return <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
		<Typography variant="subtitle2">
            {title}
        </Typography>

        { url &&  <Link href={url} target="_blank" sx={{ cursor: "pointer", color: 'text.primary'}}>
            <IconSeeker 
                icon={'arrow-up-right-from-square'} 
                sx={{ fontSize: '0.8rem', mr: 0.5, margin: .3, color: 'primary.main'}}
                tooltip={tooltip}
            />
        </Link>}
          
    </Box>
}